export default {
      id: "video-play-popup-usage",
      viewBox: "0 0 9 12",
      url: __webpack_public_path__ + "img/icons.svg#video-play-popup",
      toString: function () {
        return this.url;
      }
    }